import web from "@/core/middlewares/web";
import prefix from "@/core/utils/prefix-routes";

let email = () => import(/* webpackChunkName: "settings" */ '@/views/settings/Email');
let sms = () => import(/* webpackChunkName: "settings" */ '@/views/settings/SMS');
let captcha = () => import(/* webpackChunkName: "settings" */ '@/views/settings/Captcha');
let oauth = () => import(/* webpackChunkName: "settings" */ '@/views/settings/Oauth');
let maintenance = () => import(/* webpackChunkName: "settings" */ '@/views/settings/Maintenance.vue');


 export default [
    ...prefix("/settings",[
        {
            path: "email",
            name: "settings.email",
            component: email,
            meta: {
                middleware: web,
                permissions: ['settings:email'],
                title: "تنظیمات ایمیل"
            }
        },
        {
            path: "sms",
            name: "settings.sms",
            component: sms,
            meta: {
                middleware: web,
                permissions: ['settings:sms'],
                title: "تنظیمات پیامک"
            }
        },
        {
            path: "oauth",
            name: "settings.oauth",
            component: oauth,
            meta: {
                middleware: web,
                permissions: ['settings:oauth'],
                title: "تنظیمات oAuth"
            }
        },
        {
            path: "captcha",
            name: "settings.captcha",
            component: captcha,
            meta: {
                middleware: web,
                permissions: ['settings:captcha'],
                title: "تنظیمات کپچا"
            }
        },
        {
            path: "maintenance-mode",
            name: "settings.maintenance-mode",
            component: maintenance,
            meta: {
                middleware: web,
                permissions: ['settings:maintenanceMode'],
                title: "تنظیمات تعمیر و نگه داری"
            }
        },

    ]),
]